import { render } from "./ImageSquareCircle.vue?vue&type=template&id=195db5b7"
import script from "./ImageSquareCircle.vue?vue&type=script&lang=js"
export * from "./ImageSquareCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__